import { colors } from "./colors";

export const palette = {
  mode: "light",
  contrastThreshold: 4.5,
  common: {
    black: colors.black,
    white: colors.white,
  },
  primary: {
    main: colors.blue[500],
    light: "#1b5ba0",
    dark: "#010c28",
    contrastText: colors.white,
    bright: colors.blue[50],
  },
  secondary: {
    main: colors.pink[500],
    light: "#e24b98",
    dark: "#941e66",
  },
  text: {
    primary: colors.black,
    secondary: colors.grey[800],
    disabled: colors.grey[600],
  },
  error: {
    main: colors.red[500],
    dark: "#a11010",
    light: "#e06060",
    bright: colors.red[50],
  },
  warning: {
    main: colors.orange[500],
    light: "#d66310",
    dark: "#66320f",
    bright: colors.orange[50],
  },
  info: {
    main: "#02628b",
    dark: "#003248",
    light: "#058bc4",
    bright: colors.lightBlue[150],
  },
  success: {
    main: "#115c36",
    dark: "#0c4025",
    light: "#157445",
    bright: colors.green[50],
  },
  outlineInput: {
    default: colors.grey[600],
  },
  helpWidget: {
    dark: colors.blue[800],
    border: colors.white,
  },
  utility: {
    mockMode: "#ff6b6b",
    overlay: "rgba(0, 0, 0, 0.12)",
  },
  action: {
    active: "rgba(0, 0, 0, 0.56)",
    focus: "rgba(0, 0, 0, 0.12)",
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "rgba(0, 0, 0, 0.12)",
    backdrop: "rgba(0, 0, 0, 0.5)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
  grey: colors.grey,
};
